import httpCommon, { scheduler, scheduler_with_download_progress } from "../../http-common";


const schedule_post = (endpoint, data) => {
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  };
  return scheduler_with_download_progress.post(endpoint, data, config);
};

const schedule_progress_dummy = () => {
  return scheduler.get("/v1/qc_progress/");
};

const post_analyst_all = (analyst_array) => {
  httpCommon.post(`v1/qc/availability/analyst`, analyst_array);
};

const patch_analyst = (analyst_id_availaibility) => {
  httpCommon.patch(`v1/qc/analyst_availability`, analyst_id_availaibility);
};

const patch_machine = (machine_availaibility) => {
  return httpCommon.patch(`v1/qc/machine_availability`, machine_availaibility);
};

export const App_Service = {
  schedule_post,
  schedule_progress_dummy,
  post_analyst_all,
  patch_analyst,
  patch_machine
};